import { connect } from 'react-redux'
import MaintainStock from './MaintainStock'
import React, { Component, useEffect, useState } from 'react'
import { Button, FormControl, Form, Modal, Table } from 'react-bootstrap'
import { dummy_addToStock, dummy_removeFromStock, dummy_resetAddStock } from '../../store/actions/index'

import '../../index.css'
import DeliveryOrder from '../presentational-components/DeliveryOrder'
import { FetchCreateTransaction, FetchCreateTransactionDraft, FetchUpdateTransactionDraft } from '../../fetcher'
import AlertMessage from '../presentational-components/AlertMessage'
import { ModalComponent } from '../presentational-components/ModalComponent'

const MaintainStockList = ({ dispatch, removeOrderEntry, addToStock, transactionType = "NewArrivals", remark, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate = false, draftSysId = null, transactionNumber = "", transactionDate = "" }) => {
    let type


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const OpenModal = () => {
        return (
            handleShow()
        )
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [hasInvalidArticles, setHasInvalidArticles] = useState(false)

    const [isCreating, setIsCreating] = useState(false)

    const submitStock = () => {
        //if (type.value == 'Neuzugang' || type.value == 'Verkauf') {
        //    const transactionToCreate = {
        //        TransactionType: type.value == "Neuzugang" ? "NewArrivals" : "Sale",
        //        SerializedArticleData: JSON.stringify(addToStock),
        //    };
        //    FetchCreateTransaction(transactionToCreate, handleClose, openAlert)
        //}
        const transactionToCreate = {
            TransactionType: transactionType,
            SerializedArticleData: JSON.stringify(addToStock),
            Remark: remark,
            CreateTransactionFromDraft: isDraftUpdate,
            ToLowerStock: transactionType === "CorrectionForNewArrivals",
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate
        };
        isDraftUpdate ? /*-- do create Transaction from draft here --*/ FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)
            : FetchCreateTransaction(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)

        //resetOrderEntries()

        //if (handleCloseMask != null) {
        //    handleCloseMask()
        //}
        handleClose()
    }

    const saveStock = () => {
        console.log("saveStock ", transactionType)
        const transactionToCreate = {
            TransactionType: transactionType,
            SerializedArticleData: JSON.stringify(addToStock),
            Remark: remark,
            CreateTransactionFromDraft: false,
            ToLowerStock: transactionType === "CorrectionForNewArrivals",
            TransactionNumber: transactionNumber,
            TransactionDate: transactionDate
        };
        console.log("transactionToCreate ", transactionToCreate)

        isDraftUpdate ? FetchUpdateTransactionDraft(transactionToCreate, draftSysId, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)
            : FetchCreateTransactionDraft(transactionToCreate, handleCloseMask, openAlert, reloadParent, resetOrderEntries, setIsCreating)

        //resetOrderEntries()

        //if (handleCloseMask != null) {
        //    handleCloseMask()
        //}
        handleClose()
    }

    useEffect(() => {
        console.log("dispatch, removeOrderEntry, addToStock, transactionType, remark, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate, draftSysId, transactionNumber, transactionDate : ", dispatch, removeOrderEntry, addToStock, transactionType = "NewArrivals", remark, resetOrderEntries, handleCloseMask, reloadParent, isDraftUpdate, draftSysId, transactionNumber, transactionDate)
    }, [])

    return (
        <div className="listtable table-width">
            <Form onSubmit={e => {
                e.preventDefault()
                OpenModal()
            }}>
                <Table striped hover aria-labelledby="tabelLabel" size="sm">
                    {addToStock.map(entry =>
                        <DeliveryOrder removeOrderEntry={removeOrderEntry} {...entry} isDeliveryOrder={false} setHasInvalidArticles={setHasInvalidArticles} />
                    )}
                </Table>

                <br />

                {/*<FormControl as="select" required defaultValue="default" className="form typeForm"*/}
                {/*    focusFirstItemOnShow='keyboard' ref={node => type = node} size="sm">*/}
                {/*    <option disabled value="default">Art auswählen</option>*/}
                {/*    <option>Neuzugang</option>*/}
                {/*    <option>Verkauf</option>*/}
                {/*</FormControl>*/}

                {addToStock != null && addToStock.length != 0 && <Button variant="secondary" type="submit" disabled={isCreating || transactionDate == ""}>Bestand Aktualisieren</Button>}
            </Form>

            <ModalComponent handleShow={show} handleClose={handleClose} handleSubmit={submitStock} isDraftModal={true} handleSave={saveStock}
                modalTitle="Bestand Aktualisieren"
                modalBody="Möchten Sie den Bestand um die angegebenen Artikel verändern? Sie können die Bestandsveränderung zwischenspeichern oder abschicken. Nach dem Abschicken ist eine Änderung nicht mehr möglich." />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}


const mapStateToProps = state => ({
    addStock: (state.addStock)
})


export default connect(mapStateToProps)(MaintainStockList)